import {Badge} from "@mantine/core"
import {
    OrganizationAccount,
    OrganizationAccountStatus
} from "../types.ts";

export const OrganizationAccountStatusBadge = ({record}: { record: OrganizationAccount }) => {

    if (record.accountStatus === OrganizationAccountStatus.ACTIVE) {
        return <Badge color={'green'}>Active</Badge>;
    } else if (record.accountStatus === OrganizationAccountStatus.INACTIVE) {
        return <Badge color={'red'}>Inactive</Badge>
    }
}